import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom from "../../../../dist/jsx-render/dom";
import { IWidgetComponent } from "./IWidgetComponent";
import { WidgetText } from "../Widgets/WidgetText";
import { LanguageString } from "../../../Model/LanguageString";
import { app } from "../../../Frame/App";
import { html } from "d3";
import { WidgetHasMeasures } from "../Widgets/WidgetHasMeasures";
import { IHasMeasuresData } from "../Server/IHasMeasuresData";
import { WaitPanelComponent } from "../../Table/WaitPanelComponent";
import { MeasureEditFactory } from "../../../Pages/Measure/MeasureEditFactory";
import { PopupCloseType, PagePopup } from "../../PagePopup";

export type WidgetHasMeasuresComponentProps = {
    widget: WidgetHasMeasures;
}

export class WidgetHasMeasuresComponent extends JSXComponent implements IWidgetComponent {
    props: WidgetHasMeasuresComponentProps;

    constructor(props: WidgetHasMeasuresComponentProps) {
        super(props);
    }

    title: LanguageString;
    waitPanel: HTMLElement;
    renderWaitPanel(): HTMLElement {
        this.waitPanel = <WaitPanelComponent />
        return this.waitPanel;
    }

    element: HTMLElement;
    getElement = () => {
        if (this.props.widget.props.title) {
            this.title = LanguageString.fromPartial(this.props.widget.props.title);
        } else {
            this.title = new LanguageString();
        }

        this.element = <div className="widget Background-Blur-90-MSO has-measures">
            {this.title.inLanguage
                ? <div className="title-row">
                    <div className="title mr-auto">{(this.props.widget.props.title[`value${app.languageUpperCase}`] && this.props.widget.props.title[`value${app.languageUpperCase}`].trim().length > 0) ? this.props.widget.props.title[`value${app.languageUpperCase}`] : this.props.widget.props.title[`value${app.defaultLanguageUpperCase}`]}</div>
                </div>
                : []}

            <div className="content-row">
                <div className="widget-has-measures-content">

                    {this.renderWaitPanel()}

                </div>
            </div>
        </div>;
    }

    renderContent = (data: IHasMeasuresData): HTMLElement => {
        let textElement: HTMLElement = <div className="has-measures-any"></div>

        if (data.count > 0) {
            if (this.props.widget.props.textAny) {

                if (this.props.widget.props.iconCssClass) {
                    textElement.classList.add("flex-row")

                    // Use both text and icon
                    let iconElement = <div className={"fa " + this.props.widget.props.iconCssClass}></div>;
                    let innerTextElement = <div className="ml-1">{this.props.widget.props.textAny}</div>;

                    textElement.appendChild(iconElement);
                    textElement.appendChild(innerTextElement);
                } else {
                    textElement.innerText = this.props.widget.props.textAny;
                }

            } else if (this.props.widget.props.iconCssClass) {
                textElement.classList.add("fa", this.props.widget.props.iconCssClass);
            }
        } else {
            if (this.props.widget.props.textNone) {
                textElement.innerText = this.props.widget.props.textNone;
            }
        }

        if (data.firstId) {
            textElement.classList.add("pointer");
            textElement.addEventListener("click", (event: MouseEvent) => {

                if (!app.isNullOrUndefined(this.props.widget.props.rowClickUrl) && this.props.widget.props.rowClickUrl != "") {
                    var url = app.resolveUrl(this.props.widget.props.rowClickUrl.replace("{id}", data.firstId.toString()));
                    if (this.props.widget.props.rowClickUrlUsePopup) {
                        const popup = new PagePopup({
                            url: url,
                            resultId: data.firstId,
                            showCloseButton: false,
                            fullScreen: true,
                            onClose: (reason: PopupCloseType, id: number): boolean => {
                                if (reason == "save") {
                                    document.location = document.location;
                                }
                                return true;
                            }

                        });
                    } else {
                        document.location.href = url;
                    }
                } else {
                    MeasureEditFactory.showMeasure({
                        measureId: data.firstId,
                        templateId: 0,
                        parentId: 0,
                        parentGuid: null,
                        fullScreen: true,
                        onClose: ((reason: PopupCloseType, id: number) => {
                            if (reason == "save") {
                                document.location = document.location;
                            }
                        })
                    });
                }
            });
        }

        return textElement;
    }

    private load = () => {
        $.ajax({
            type: "POST",
            url: app.resolveUrl("~/api/widget/checkHasMeasures"),
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify({
                templateIds: this.props.widget.props.templateIds,
                additionalFilter: this.props.widget.props.additionalFilter
            }),
            success: (data: IHasMeasuresData) => {
                let content = this.renderContent(data);

                this.waitPanel.parentElement.insertBefore(content, this.waitPanel);
                this.waitPanel.parentElement.removeChild(this.waitPanel);
                this.waitPanel = null;
            },
            error: ((response) => {
                app.addError(response.statusText + ": " + response.responseText);
            })
        });
    }

    public render(): HTMLElement {
        this.getElement();

        this.load();

        this.props.widget.setGridPosition();
        return this.element;
    }
}